/*
 *   File : amount-input.js
 *   Author : https://evoqins.com
 *   Description : Amount input component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// packages
import React, { memo, useEffect, useState } from 'react';

//custom style
import style from "../../Style/Component/input.module.scss";

const AmountInput = (props) => {

    const [isInputFocused, setIsInputFocused] = useState(false);

    // handle focus 
    const _handleFocus = () => {
        setIsInputFocused(true);
    };

    const _handleBlur = () => {
        setIsInputFocused(false);
    };

    //input handle change
    const _handleChange = (e) => {
        let value = e.target.value;
        props.handleChange(value);
    };

    // handle enter key press
    const keyPress = (e) => {
        if (e.keyCode === 13) {
            props.onKeyPress();
        }
    };

    const _handleKeyDown = (e) => {
        // Prevent default behavior of up and down arrow keys
        if (e.keyCode === 38 || e.keyCode === 40 || e.key === '0' && props.value === '' || e.key === '.' || e.key === 'e' || e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
    };

    return (
        <div className={props.wrapperClass} ref={props.ref} >
            {props.label &&
                <label className={`${props.labelStyle} d-flex e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className={`${style.e_amount_input_wrapper} position-relative`}>
                <div className={` ${props.error && style.e_error_border} ${isInputFocused ? `${style.e_active} ` : `${style.e_inactive} `} border-radius-8`}>
                    <input id={props.id}
                        ref={props.ref}
                        value={props.value}
                        defaultValue={props.defaultValue}
                        maxLength={props.maxLength}
                        tabIndex={props.tabIndex}
                        type="number"
                        required={props.required}
                        readOnly={props.readOnly}
                        autoFocus={props.autoFocus}
                        placeholder={props.placeholder}
                        className={`${style.e_input} ${props.className} e-primary-font ${props.noIcon !== true ? 'padding-24px-left padding-16px-right' : 'padding-16px-lr'}  py-3   border-0 border-radius-8 e-bg-white e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px`}
                        onWheel={() => document.activeElement.blur()}
                        onFocus={_handleFocus}
                        onBlur={_handleBlur}
                        onChange={_handleChange}
                        onKeyDown={(e) => {
                            keyPress(e);
                            _handleKeyDown(e);
                        }}
                        onClick={props.onClick} />
                </div>

                {props.noIcon !== true && <span className='position-absolute top-17px left-16px e-text-chinese-black e-primary-font e-font-14 line-height-16px e-font-weight-400'>
                    ₹
                </span>}

                {props.percentage === true && <span className='position-absolute top-17px right-16px e-text-chinese-black e-primary-font e-font-14 line-height-16px e-font-weight-400'>
                    %
                </span>}

                {props.year === true && (
                    <span className='position-absolute top-17px right-16px e-text-chinese-black e-primary-font e-font-14 line-height-16px e-font-weight-400'>
                        {props.value > 1 ? 'Yrs' : 'Yr'}
                    </span>
                )}


                {props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }
            </div>
        </div >
    )
}

AmountInput.defaultProps = {
    onKeyPress: () => { },
    className: null,
    error: "",
    value: "",
}

export default memo(AmountInput);